@switch (viewer()) {
    @case (viewers.EML) {
        @if (blobUrl() && extension() && toastId()) {
            <sh-eml-viewer [blobUrl]="blobUrl()" [extension]="extension()" [toastId]="toastId()"></sh-eml-viewer>
        }
    }
    @case (viewers.IMAGE) {
        @if (safeUrl() && extension()) {
            <sh-image-viewer [blobUrl]="safeUrl()" [extension]="extension()"></sh-image-viewer>
        }
    }

    @case (viewers.PDF) {
        @if (blobUrl() && extension()) {
            <sh-pdf-viewer [blobUrl]="blobUrl()" [extension]="extension()"></sh-pdf-viewer>
        }
    }
    @case (viewers.MEDIA) {
        @if (blobUrl() && extension()) {
            <sh-video-viewer [blobUrl]="blobUrl()" [extension]="extension()"></sh-video-viewer>
        }
    }
    @case (viewers.WARC) {
        @if (extension() && originalSourceUrl()) {
            <sh-warc-viewer [originalSourceUrl]="originalSourceUrl()" [extension]="extension()"></sh-warc-viewer>
        }
    }
    @default {
        @if (blobUrl() && extension()) {
            {{ "viewer.error.unsupported-extension" | translate }}
        }
    }
}
